<template>

    <v-event :date="page.last_visited_at" :actions="[{ key: 'delete', value: 'Delete Page' }]" @action="onActionSelected">
        <template #title>
            <span class="title">{{ page.url.path | truncate(100) }}</span>
        </template>
        <template #body>
            <table>
                <tr>
                    <td class="key">host</td>
                    <td class="value">{{ page.url.host }}</td>
                </tr>
                <tr>
                    <td class="key">path</td>
                    <td class="value">{{ page.url.path }}</td>
                </tr>
                <tr>
                    <td class="key">last visited</td>
                    <td class="value">{{ page.last_visited_at | dateTime }}</td>
                </tr>
                <tr>
                    <td class="key">first visited</td>
                    <td class="value">{{ page.first_visited_at | dateTime }}</td>
                </tr>
                <tr>
                    <td class="key">number of visits</td>
                    <td class="value">{{ page.count | numeral('0,0') }}</td>
                </tr>
            </table>
        </template>
    </v-event>

</template>

<script>

import CustomerApi from '@api/CustomerApi';
import Event from './Event';

export default {

    components: {
        'v-event': Event,
    },

    props: {
        page: {
            type: Object,
            required: true,
        },
    },

    methods: {

        onActionSelected(item) {
            if (item.key === 'delete') {
                CustomerApi.deletePage(this.charge.customer_id, this.page.id)
                    .then((response) => {
                        this.$store.commit('setAlertSuccess', this.$t('message.deleted'));
                        this.$emit('deleted');
                    }, (error) => {
                        this.$store.commit('setAlertWithError', error);
                    });
            }
        },

    },

}

</script>
